import { useEffect, useState } from 'react';
import { dehydrate } from 'react-query';
import { Layout } from '@vfit/consumer/components';
import { GRANDIAZIENDE_CMS_DEFAULT, IPage } from '@vfit/grandiaziende/data-access';
import {prefetchStaticPathsGrandiAziende, prefetchPagesGrandiAziende, prefetchDataGrandiAziende} from '@vfit/cms';
import { initApp, usePage, useTranslate } from '@vfit/consumer/data-access';

export default function PageBuilder() {
  const { translate, initDefaultMultiLang } = useTranslate(GRANDIAZIENDE_CMS_DEFAULT);
  const { page } = usePage();
  const [loading, setLoading] = useState<boolean>(true);

  const isPageNotFound = (): boolean => {
    return !!(page?.params?.isEnabledNotFound && page?.params?.notFoundRedirectUrl);
  };

  useEffect(() => {
    if (isPageNotFound()) {
      window.location.href = `${window.location.origin}${page?.params?.notFoundRedirectUrl}`;
    } else {
      translate();
      initApp();
      setLoading(false);
    }
  }, []);

  if (loading) {
    initDefaultMultiLang();
    return null;
  }

  return <Layout />;
}

export async function getStaticPaths() {
  const allPaths = await prefetchStaticPathsGrandiAziende();
  return {
    paths: allPaths,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const contextPath = params?.path?.join('/') || '';
  const allPages = await prefetchPagesGrandiAziende();
  // Find current page
  let page: IPage = null;
  Object.keys(allPages).forEach((pK) => {
    const lPage = allPages[pK];
    if (lPage.params?.path?.join('/') === contextPath) page = lPage;
  });
  // prefetch data for page
  const queryClient = await prefetchDataGrandiAziende(page);
  return {
    props: {
      page: page || null,
      dehydratedState: dehydrate(queryClient),
    },
  };
}
